// removed by extract-text-webpack-plugin
module.exports = {"tab-content":"TabAbout-module-tab-content-2ETSF","tabContent":"TabAbout-module-tab-content-2ETSF","table":"TabAbout-module-table-EJDx9","cell":"TabAbout-module-cell-Rt0eQ","row":"TabAbout-module-row-2CBwc"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/components/TabAbout/TabAbout.module.scss
// module id = 1219
// module chunks = 0